import React from 'react'
import BaseForm from './base-form.component'
import StyledStepFrom from './styled-step-from.component'
import PersonalForm from './personal-form.component'

export default class StepOnePersonalForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<PersonalForm
					initialValues={this.props.initialValues}
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
				/>
			</StyledStepFrom>
		)
	}
}
